/* eslint-disable no-unused-vars */
import { Field, reduxForm } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RenderField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { editTable, fetchAllTable } from '../../../../actions/SeatingChartActions';

import './TableModal.less';
import { showModal } from '../../../../actions/ModalActions';

const EditTableModal = ({ handleSubmit, pristine, submitting, valid, onDelete }) => (
  <div>
    <div className="modal-header">
      <h3 className="modal-title">Edit Table</h3>
    </div>
    <form onSubmit={handleSubmit} id="table-form" className="tableModal__form" noValidate>
      <Field
        component={RenderField}
        name="table-number"
        label="Table Name"
        type="text"
        id="event-name"
        placeholder="8"
        required
        validate={Validations.REQUIRED}
      />
      <Field
        component={RenderField}
        name="seat-number"
        label="Number of Seats"
        type="text"
        id="event-name"
        placeholder="5"
        required
        validate={Validations.REQUIRED}
      />
      <div className="tableModal__buttonGroup">
        <button className="btn btn-primary tableModal__form--delete" onClick={onDelete}> Delete Table </button>
        <RenderSubmitButton className="tableModal__form--save" pristine={pristine} submitting={submitting} valid={valid} />
      </div>
    </form>
  </div>
);

EditTableModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onSubmit: createTaskRequest => dispatch(editTable(createTaskRequest)).then(() => {
      ownProps.hideModalFn();
      dispatch(fetchAllTable());
    }),
    onDelete: () => dispatch(showModal('DELETE_TABLE_MODAL', {}, { size: 'sm' })),
  }
);

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'table_form'
})(EditTableModal));



/** WEBPACK FOOTER **
 ** ./src/components/manage/seatingchart/seatingChartModals/EditTableModal.jsx
 **/